<mat-toolbar id="toolbar" color="primary">
    <a routerLink="/" class="brandname-link">
    <img id="toolbar-logo" height="40" width="40" src="assets/app-icons/icon-40x40.webp" alt="{{siteName}} Logo">
    </a>
    <a routerLink="/" class="brandname-link">
        <span id="brandname">{{siteName}}</span>
        </a>
    <span class="example-spacer"></span>
    <ng-content></ng-content>
</mat-toolbar>
